export default "__VITE_ASSET__BGJz$tXM__"